import React from 'react';
import AddressAutocomplete from './AddressAutocomplete';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const ParticipantRow = ({ 
  participant, 
  index, 
  onNameChange,
  onLocationChange, 
  onTransportChange, 
  onRemove, 
  onUseCurrentLocation,
  onValidationChange,
  canRemove,
  nameError,
  locationError,
  transportError 
}) => {
  const transportOptions = [
    { 
      value: 'driving', 
      label: 'Driving',
      description: 'Personal vehicle or car service'
    },
    { 
      value: 'walking', 
      label: 'Walking',
      description: 'On foot'
    },
    { 
      value: 'transit', 
      label: 'Public Transit',
      description: 'Bus, train, or subway'
    },
    { 
      value: 'bicycling', 
      label: 'Bicycling',
      description: 'Bike or e-bike'
    }
  ];

  return (
    <div 
      className="bg-card border border-border rounded-xl p-4 md:p-6 transition-smooth hover:shadow-md"
      data-participant-index={index}
    >
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
            <Icon name="User" size={20} className="text-primary" />
          </div>
          <div>
            <h3 className="font-heading font-semibold text-foreground">
              Participant {index + 1}
            </h3>
            <p className="caption text-muted-foreground">
              Enter details for this participant
            </p>
          </div>
        </div>
        {canRemove && (
          <Button
            variant="ghost"
            size="icon"
            onClick={onRemove}
            iconName="X"
            className="text-muted-foreground hover:text-destructive"
            aria-label={`Remove participant ${index + 1}`}
          />
        )}
      </div>
      <div className="space-y-4">
        <Input
          label="Participant Name"
          type="text"
          placeholder="Enter name (e.g., John Smith)"
          value={participant?.name}
          onChange={(e) => onNameChange(index, e?.target?.value)}
          error={nameError}
          required
        />

        <AddressAutocomplete
          value={participant?.location}
          onChange={onLocationChange}
          onValidationChange={onValidationChange}
          index={index}
          error={locationError}
          required
          placeholder="Enter address or place name"
          onUseCurrentLocation={onUseCurrentLocation}
        />

        <Select
          label="Transportation Method"
          description="How will you travel to the meeting?"
          options={transportOptions}
          value={participant?.transport}
          onChange={(value) => onTransportChange(index, value)}
          error={transportError}
          required
          placeholder="Select transportation"
        />
      </div>
    </div>
  );
};

export default ParticipantRow;